import { useEffect } from "react";

const SITE = "CalibRunway";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

// Per-page title, description, canonical and share-preview tags.
export const usePageMeta = ({ title, description, path }) => {
  useEffect(() => {
    const url = window.location.origin + path;
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", SITE);
    setMeta("name", "twitter:card", "summary");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = url;
  }, [title, description, path]);
};

export const PAGE_META = {
  home: { path: "/", title: "CalibRunway: Cash runway forecasting for startup founders",
    description: "Sync Stripe, your bank and QuickBooks into one live runway model, see your Zero Cash Date, and test hires or raises with AI before you commit. 14-day free trial, no card." },
  features: { path: "/features", title: "Features: Multi-Sync runway, expense toggles and AI scenarios | CalibRunway",
    description: "Live runway from Stripe, bank and QuickBooks, automatic expense categories, vendor cut-off modeling and an AI Scenario Calibrator that shows every number it changed." },
  pricing: { path: "/pricing", title: "Pricing: Starter $29/mo, Pro $79/mo, 14-day free trial | CalibRunway",
    description: "Starter for pre-seed founders and Pro for seed+ teams. Both start with a 14-day free trial, no card required. Pay yearly and save 10%. Cancel anytime." },
  about: { path: "/about", title: "About CalibRunway: Built by Sonia Montez | A Nolasco Group brand",
    description: "CalibRunway was built by Sonia Montez after decades of consulting on startup operations and building cash-flow spreadsheets for founders." },
  security: { path: "/security", title: "Security and data handling | CalibRunway",
    description: "How CalibRunway reads your Stripe, bank and QuickBooks data, where it is stored, and what we never do with it: no moving money, no selling data." },
};
